import { FC, ReactNode } from "react";
import NativeBridge from "services/native-bridge/native-bridge";
import { ButtonTitle } from "../../../styles/typography/ButtonTitle.styled";
import StyledExternalLinkButton from "./styles/StyledExternalLinkButton.styled";

interface LinkButtonProps {
  href: string;
  children: ReactNode;
}

const ExternalLinkButton: FC<LinkButtonProps> = ({ children, href }) => {
  const handleClick = (e: React.MouseEvent) => {
    if (NativeBridge.shared.isEmbedded) {
      e.preventDefault();
      NativeBridge.shared.openExternalLink(href);
    }
  };

  return (
    <StyledExternalLinkButton
      href={href}
      target="_blank"
      onClick={handleClick}
    >
      <ButtonTitle>{children}</ButtonTitle>
    </StyledExternalLinkButton>
  );
};

export default ExternalLinkButton;
